import { makeStyles, Theme } from "@material-ui/core";

const useStyles = makeStyles((theme: Theme) => ({
  divider: {
    marginBottom: theme.spacing(2),
  },
  assignmentSubHeader: {
    display: "block",
    fontSize: "1rem",
    fontWeight: "bold",
    lineHeight: "1.5rem",
  },
  assignmentSubtitle: {
    ...theme.typography.subtitle2,
  },
}));

export default useStyles;
